import React from 'react';
import clsx from 'clsx';

// Material components
import { Box, Divider, Icon, makeStyles } from '@material-ui/core';

// core components
import FileDetail from './FileDetail';
import ShippingBttnV2 from './ShippingBttnV2'; // Revertimos al componente V2

// Shared Utils
import dateFormat from '../../../design-system/utils/dateFormat';

// Constants
import { SIMPLE_DATE_FORMAT } from '../../../design-system/constants/date-formats';
import { PHYSICAL_REJECTED_STATUS } from '../../../shared/constants/record-status';

const useStyles = makeStyles((theme) => ({
    container: {
        [theme.breakpoints.down('sm')]: {
            flexDirection: "column"
        }
    },
    containerShippingGuideButton: {
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        },
    }
}));

const DeliveryGroupPhysicalDocs = ({ listGroup, locationCatalog = {}, styleLearning, templateId = 0, onSuccess }) => {
    const classes = useStyles();

    return (
        listGroup.map((programObj, programIndex, { length }) =>
            <Box key={`list-programs-item-${programIndex}`}>
                <Box p={3} display='flex' alignItems='left' gridGap='24px' className={classes.container}>
                    <Box display='flex' flexDirection='row' gridGap={38} alignItems='center' flex={1}>
                        <Icon className="ri-file-text-line"
                            style={{ color: [PHYSICAL_REJECTED_STATUS].includes(programObj.documents[0].record_status_id) ? '#F74F58' : '#9F6FFB', fontSize: '40px' }} />
                        <Box display="flex" flexDirection="column" gridGap="8px" flex={1}>
                            {
                                programObj.documents.map((documentObj, documentIndex) =>
                                    <Box display="flex" flexDirection="row" alignItems="left">
                                        <FileDetail
                                            displayFileIcon={false}
                                            key={`program-document-item-${programIndex}-${documentIndex}`}
                                            title={documentObj.document_name}
                                            fileName={documentObj.file_name}
                                            filePath={documentObj.path}
                                            dueDate={dateFormat(documentObj.deadline, SIMPLE_DATE_FORMAT)}
                                            active={false}
                                            flex={1}
                                            status={documentObj.record_status_id}
                                            tags={documentObj.value_list}
                                            isAdmin={false}
                                            downloadableFile={!!documentObj.file_id_downloadable && documentObj.path_downloadable}
                                            instruction={documentObj.instruction}
                                            messageToUser={documentObj.record_status_id === PHYSICAL_REJECTED_STATUS ? documentObj.error_message : ""}
                                        />
                                    </Box>
                                )
                            }
                        </Box>
                    </Box>
                    <Box minWidth={215} className={classes.containerShippingGuideButton} display="flex" alignItems="center">
                        <ShippingBttnV2 styleLearning={styleLearning} templateId={templateId} onSuccess={onSuccess} /> {/* Revertimos al botón V2 */}
                    </Box>
                </Box>
                {programIndex < length && <Divider className='bg-fill-stroke-200' />}
            </Box>
        ));
};

export default DeliveryGroupPhysicalDocs;